import Vue from "vue";
import VueI18n from "vue-i18n";
import vi from "./lang/vi";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "vi",
  fallbackLocale: "vi",
  messages: {
    vi,
  },
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js